<template>
  <b-modal
    :id="`member-note${id}`"
    modal-class="modal-style"
    ref="modal"
    v-model="modal"
    size="lg"
  >
    <template>
      <p class="modal-style-title not-one-row">會員備註</p>
      <div class="modal-style-content">
        <div class="member-info">
          <h5>{{ memberName }}</h5>
        </div>
        <div class="note-content">
          <p
            v-if="memberDescription && memberDescription.trim()"
            class="note-text"
          >
            {{ memberDescription }}
          </p>
          <p v-else class="no-note-text">
            此會員無備註資訊
          </p>
        </div>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button class="custom-btn modal-style-single-btn" @click="closeModal()">
        確定
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
      type: Number
    },
    memberName: {
      required: true,
      type: String
    },
    memberDescription: {
      required: false,
      type: String,
      default: ''
    }
  },
  data() {
    return {
      modal: false
    };
  },
  watch: {
    modal(next) {
      if (next == false) {
        this.$emit('closeModal');
      }
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(`member-note${this.id}`);
    }
  }
};
</script>

<style scoped>
.member-info h5 {
  margin-bottom: 15px;
  color: #333;
  font-weight: bold;
}

.note-content {
  min-height: 100px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 5px;
  border: 1px solid #e9ecef;
}

.note-text {
  margin: 0;
  line-height: 1.6;
  color: #495057;
  white-space: pre-wrap;
  word-break: break-word;
}

.no-note-text {
  margin: 0;
  color: #6c757d;
  font-style: italic;
  text-align: center;
}
</style>
